import { Routes, Route, Outlet } from "react-router-dom";
import SolarGridControl from "../pages/SolarGridControl";

export default function SolarGridControlRoutes() {
    return (
        <>
            <Routes>
                <Route path="/" element={<SolarGridControl />} />
            </Routes>
            <Outlet />
        </>
    );
}
